// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "wap/static/css/" + chunkId + "." + {"33":"d269d2d4","187":"8c68936a","456":"9e8cccae","484":"769059a0","778":"26c13e49","962":"a2326794"}[chunkId] + ".css";
};